import React, {useEffect, useState} from 'react';
import {Form, Col, Button, Dropdown, DropdownButton, InputGroup, SplitButton} from 'react-bootstrap';
import {useFormik} from 'formik';
import * as yup from 'yup';
import noSource from '../../assets/img/no-report.png';
import filter from '../../assets/img/filter.png';
import trash from '../../assets/img/trash.png';
import micro_reporter_api from "../../apis/micro-reporter-api";
import MultiSelectComponent from "./MultiSelectComponent";
import Utils from "../../libraries/utils";
import DatePickerComponent from "./DatePickerComponent";
import TextInputComponent from "./TextInputComponent";
import NumericInputComponent from "./NumericInputComponent";


const InputGenerator = (props) => {

    let initialValues = {};

    const [fields, setFields] = useState([]);
    const [resetSelect, setResetSelect] = useState(false);

    let multiSelectedOptions = {};
    const setMultiSelectedOptions = (obj) => {
        multiSelectedOptions = Object.assign(multiSelectedOptions, obj);
        setResetSelect(false)
    }

    const resetSelectChange = () => {
        setResetSelect(false)
    }

    useEffect(() => {
        getFields();
    }, []);

    const getFields = () => {
        try{
            Utils.loadingScreen("show");
            (async () => {
                await micro_reporter_api.get(`/micro-reporter/field/by-report-id?reportId=${props.rid}`).then(
                    (response) => {
                        setFields(response.data);
                        setTimeout(() => {
                            Utils.loadingScreen("hide");
                        }, 250);
                    }
                )
            })();
        }catch (err) {
            Utils.loadingScreen("hide");
        }

    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: yup.object({

        }),
        onSubmit: values => {
            props.setOffset(0);
            values = convertFormikValuesToArray(values);
            values = Object.assign(values, multiSelectedOptions);
            props.setVals({values: values});
        },
    });

    const convertFormikValuesToArray = (values) => {
        let map = new Map();
        for (const [key, value] of Object.entries(values)) {
            let options = [];
            if (!key.includes('-mr-') && value !== ""){
                let second = values[key  + '-mr-2'] === undefined ? null : values[key  + '-mr-2'];
                let filterType = values[key  + '-mr-filter-type'] === undefined ? document.getElementsByName(key  + '-mr-filter-type')[0].value : values[key  + '-mr-filter-type'];
                let filterData = {};
                filterData["first"] = value;
                filterData["second"] = second;
                filterData["filterType"] = filterType;

                if (map.get(key) === undefined){
                    options.push(filterData);
                    map[key] = options;
                }else {
                    map[key].push(filterData);
                }
            }
        }
        return map;
    }

    const renderInputs = () => {
        if (fields.length > 0){
            return fields.map(field => {
                if (field.fieldType.typeCode === 100){
                    initialValues[`${field.name}`] = "";
                    return(
                        <TextInputComponent field={field} formik={formik} />
                    );
                }else if (field.fieldType.typeCode === 101){
                    initialValues[`${field.name}`] = "";
                    return(
                        <MultiSelectComponent rid={props.rid} resetSelect={resetSelect} resetSelectChange={resetSelectChange} cname={field.name} field={field} formik={formik} setMultiSelectedOptions={setMultiSelectedOptions}/>
                    );
                }else if (field.fieldType.typeCode === 102){
                    initialValues[`${field.name}`] = "";
                    return(
                        <DatePickerComponent field={field} formik={formik} />
                    );
                }else if (field.fieldType.typeCode === 103){
                    initialValues[`${field.name}`] = "";
                    return(
                        <NumericInputComponent field={field} formik={formik} />
                    );
                }
            });
        }
    };

    const clearForm = () => {
        for(let i=0; i<document.getElementsByClassName("inputClear").length; i++){
            document.getElementsByClassName("inputClear")[i].value = null;
        }
        for (let i=0; i<document.getElementsByClassName('clear-selected-button').length; i++){
            document.getElementsByClassName('clear-selected-button')[i].click();
        }
        formik.resetForm();
        setResetSelect(true);
    };

    const renderButtons = () => {
        if(Object.keys(props.columnMetadata).length>0){
            props.showReportListPanel();
            return(
                <div style={{float: "right", zIndex: "0", position: "relative"}}>
                    <Button variant="secondary" onClick={() => clearForm()}>
                        <img src={trash} alt="clear" style={{width: "17px", height: "17px", marginBottom:"2px", marginRight: "5px"}}/>
                        Clear
                    </Button>
                    <Button type="submit" style={{marginLeft: "10px", width:"120px"}} >
                        <img src={filter} alt="filter" style={{width: "16px", height: "16px", marginBottom:"2px", marginRight: "5px"}}/>
                        Filter
                    </Button>
                </div>
            );
        }else{
/*             props.hideReportListPanel();
 */            setTimeout(function(){
                return(
                    <div id="record-not-found-div">
                        <div id="center-div">
                            <img src={noSource} style={{width: "100px"}} alt="No report found."/>
                            <br/>
                            <span>No report found!</span>
                        </div>
                    </div>
                );
            }, 5000);
        }
    };

    return(
        <Form noValidate id="query-form" onSubmit={formik.handleSubmit}>
            <Form.Row>
                {renderInputs()}
            </Form.Row>
            {renderButtons()}
        </Form>
    );
};

export default InputGenerator;
